;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('EditorBrandService', editorBrandService)

  /* @ngInject */
  function editorBrandService (BrandBaseService, ConnectorWebService, CONSTANTS) {
    const service = {
      getBrandColorPalettes
    }
    return angular.extend({}, BrandBaseService, service)

    function getBrandColorPalettes () {
      return ConnectorWebService.get(CONSTANTS.URL_PALETTES).then(_mapGetBrandColorPalettesResponse)
    }

    function _mapGetBrandColorPalettesResponse (palettes) {
      palettes.forEach(palette => {
        palette.colors = palette.colors.map(color => color.hex)
      })
      return palettes
    }
  }
})()
